import React from 'react';
import ReactDOM from 'react-dom';
import App from './Components/App';
import { BrowserRouter } from 'react-router-dom';

const LAB_BASENAME = '/ampliass';
const routerBaseName = window.location.pathname.startsWith(LAB_BASENAME) ? LAB_BASENAME : undefined;

ReactDOM.render( < BrowserRouter basename={routerBaseName} >
     <App />
   </BrowserRouter> , document.getElementById('root'));